import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ReactTableForm from "../../../../../components/Common/ReactTableForm";
import { formatNumbersForTableWithFixed } from "../../../../../helpers/utils";

const AggregatedTableForHR = ({
  loader,
  data,
  setTablesDataForExport,
  tableName,
  handleTableChange,
}) => {
  const [tableRows, setTableRows] = React.useState({
    defaultStyle: {
      textAlign: "center",
      width: "auto",
      verticalAlign: "middle",
    },
    // columns: [],
  });
  const [tableData, setTableData] = React.useState({ results: [] });

  const genAccessor = (type, key, row) => {
    switch (type) {
      case "string":
        return <span data-toggle="tooltip">{row[key]}</span>;
      case "number":
        return (
          <span data-toggle="tooltip">
            {formatNumbersForTableWithFixed(row[key], 1)}
          </span>
        );
      case "percent":
        return (
          <span data-toggle="tooltip">
            {formatNumbersForTableWithFixed(row[key], 1)}%
          </span>
        );
      default:
        return (
          <span className={`text-primary`} data-toggle="tooltip">
            {row[key]}
          </span>
        );
    }
  };

  const getHeadForTable = (name) => {
    let row = {
      Managers: 'Project Managers',
      Manager: 'Project Manager'
    }
    return row[name] || name
  }

  React.useEffect(() => {
    const dt = data;
    let columns = [],
      keys = [];
    if (dt?.data && dt?.data.length > 0) {
      for (let [key, val] of Object.entries(dt.data[0])) {
        if (key == "value" || key == "margin" || key == "percent") {
          keys.push({
            type: "percent",
            key,
          });
        } else {
          keys.push({
            type: typeof val === "string" ? "string" : "number",
            key,
          });
        }
      }

      if (dt?.head.length > 0) {
        dt?.head.map((i, x) => {
          columns.push({
            id: keys[x]?.key,
            Header: getHeadForTable(i),
            isSorted: true,
            src: keys[x]?.key,
            accessor: row => genAccessor(keys[x]?.type, keys[x]?.key, row),
            style: {
              maxWidth: 120,
              textAlign: keys[x]?.type === "string" ? "" : "center",
            },
            Footer:
              x == 0 ? (
                <span className={`text-left`} data-toggle="tooltip">
                  Total
                </span>
              ) : (
                () => genAccessor(keys[x]?.type, keys[x]?.key, dt.total)
              ),
          });
        });
      }
      setTableRows({ ...tableRows, columns });
      setTableData({ results: dt.data });
    }
  }, [data]);

  const cellProps = info => {
    return {
      style: {
        ...tableRows.defaultStyleColumns,
      },
    };
  };

  const handleChangeTable = (data) => {
    handleTableChange(data);
  };

  return (
    <>
      <ScrollTable>
        {!loader ? (
          <>
            <ReactTableForm
              loading={loader}
              columns={tableRows.columns}
              data={tableData}
              onTableChange={handleChangeTable}
              getCellProps={cellInfo => cellProps(cellInfo)}
              isStriped={false}
              overflow={true}
              withFooter
            />
          </>
        ) : (
          <div
            className="loader-for-react-table justify-content-center"
            style={{ display: "flex", padding: "45px 0" }}
          >
            <div className="spinner-border text-primary m-1" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
      </ScrollTable>
    </>
  );
};

const ScrollTable = styled.div`
  min-width: 279px;
  height: 100%;
  overflow-y: auto;
`;

AggregatedTableForHR.propTypes = {
  data: PropTypes.object.isRequired,
  loader: PropTypes.bool.isRequired,
  setTablesDataForExport: PropTypes.func,
  handleTableChange: PropTypes.func,
  tableName: PropTypes.string,
  // permissions: PropTypes.object.isRequired,
};

export default AggregatedTableForHR;
